// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationGroupId } from './FermentationGroup';
import { fermentationId } from './Fermentation';
import { fermentationGroupAlertId } from './FermentationGroupAlert';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationAlertSnoozeId = (z.number());
export const fermentationAlertSnooze = z.object({
    id: fermentationAlertSnoozeId,
    fermentation_group_id: fermentationGroupId,
    fermentation_id: fermentationId.nullable(),
    group_alert_id: fermentationGroupAlertId.nullable(),
    until: z.date(),
    reason: z.string().nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
});
export const fermentationAlertSnoozeInitializer = z.object({
    id: fermentationAlertSnoozeId.optional(),
    fermentation_group_id: fermentationGroupId,
    fermentation_id: fermentationId.optional().nullable(),
    group_alert_id: fermentationGroupAlertId.optional().nullable(),
    until: z.date(),
    reason: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const fermentationAlertSnoozeMutator = z.object({
    id: fermentationAlertSnoozeId.optional(),
    fermentation_group_id: fermentationGroupId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    group_alert_id: fermentationGroupAlertId.optional().nullable(),
    until: z.date().optional(),
    reason: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationAlertSnooze.js.map